import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'variant'> {
  name: string;
}

const CustomTextField: React.FC<CustomTextFieldProps> = (props) => {
  return (
    <TextField
      {...props}
      variant='filled'
      fullWidth
      required
      InputLabelProps={{
        sx: {
          color: props.error ? 'error.main' : 'text.secondary',
          '&.Mui-focused': {
            color: props.error ? 'error.main' : 'text.primary',
          },
        },
      }}
      InputProps={{
        sx: {
          color: 'text.primary',
          background: props.error
            ? 'rgba(211, 47, 47, 0.1)'
            : 'rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
        },
        disableUnderline: true,
      }}
      sx={{
        '.MuiFilledInput-root': {
          backgroundColor: props.error
            ? 'rgba(211, 47, 47, 0.1)'
            : 'rgba(255, 255, 255, 0.1)',
        },
      }}
    />
  );
};

export default CustomTextField;
